import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { DefaultModal } from "../../common/modals/default-modal/default-modal";
import { resources } from "@constants/hardcoded-strings";
import styles from "./confirm-add-backup-service-modal.less";

type ConfirmAddBackupServiceModalProps = {
    serviceName: string;
    onClickContinue: () => void;
    onModalClose: () => void;
};


export const ConfirmAddBackupServiceModal = (props: ConfirmAddBackupServiceModalProps) => {
    const { serviceName, onClickContinue, onModalClose } = props;

    return (
        <DefaultModal
            automationId="confirm-add-backup-service-modal"
            ariaLabelledBy="confirm-add-backup-service-title"
            onHide={onModalClose}
            backdrop={"static"}
            keyboard={false}
            isMaxWidth={false}
        >
            <Modal.Header id={"confirm-add-backup-service-title"} closeButton>
                <Modal.Title>{resources.modals.confirmAddBackupService.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <span className={styles.descriptionLine}>{resources.modals.confirmAddBackupService.descriptionLine1(serviceName)}</span>
                <span className={styles.descriptionLine}>{resources.modals.confirmAddBackupService.descriptionLine2(serviceName)}</span>
            </Modal.Body>
            <Modal.Footer>
                <Button id="add-backup-service-cancel-button" variant="secondary" onClick={onModalClose}>
                    {resources.common.buttons.cancel.label}
                </Button>
                <Button id="add-backup-service-submit-button" variant="primary" onClick={onClickContinue}>
                    {resources.modals.confirmAddBackupService.buttons.configureBackupService.label}
                </Button>
            </Modal.Footer>
        </DefaultModal>
    );
};